import React from 'react';
import PropTypes from 'prop-types';
import { useFormContext } from '../Form';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Box from '@material-ui/core/Box';
import MaterialToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import ToggleButton from '@material-ui/lab/ToggleButton';
import useRegisterInput from '../Form/useRegisterInput';

const ToggleButtonGroup = ({
  error,
  exclusive,
  fullWidth,
  inline,
  isEditing,
  label,
  margin,
  name,
  onChange,
  options,
  size,
  value,
  variant,
  allowDeselect,
  register: shouldRegister,
}) => {
  useRegisterInput(name, shouldRegister);

  const formContext = useFormContext();
  const {
    editInline: formInline = false,
    isEditing: formIsEditing = true,
    errors = {},
    // setIsEditing,
    setValue,
    watch,
  } = formContext || {};
  const parsedInputProps = {
    inline: inline ?? formInline,
    isEditing: isEditing ?? formIsEditing,
    error: error ?? !!errors[name],
    value: value ?? watch(name),
  };
  const isInline = parsedInputProps.inline && !parsedInputProps.isEditing;

  /**
   * Handle the change on the select.
   * @param {object|Event} ev
   * @param {any} newValue
   */
  const handleOnChange = (ev, newValue) => {
    if (formContext && !onChange) {
      if (!allowDeselect && newValue === null) {
        return;
      }

      setValue(name, newValue);
      return;
    }

    if (onChange) {
      if (!allowDeselect && newValue === null) {
        return;
      }

      onChange(ev, newValue);
    }
  };

  return (
    <FormControl fullWidth={fullWidth} variant={variant} margin={margin}>
      <InputLabel shrink>{label}</InputLabel>
      <Box mt={2}>
        <MaterialToggleButtonGroup
          name={name}
          size={size}
          value={parsedInputProps.value}
          onChange={handleOnChange}
          exclusive={exclusive}
        >
          {options.map(option => (
            <ToggleButton
              key={option.value}
              value={option.value}
              disabled={isInline || option.disabled}
            >
              {option.label}
            </ToggleButton>
          ))}
        </MaterialToggleButtonGroup>
      </Box>
    </FormControl>
  );
};

ToggleButtonGroup.propTypes = {
  allowDeselect: PropTypes.bool,
  error: PropTypes.bool,
  exclusive: PropTypes.bool,
  fullWidth: PropTypes.bool,
  inline: PropTypes.bool,
  isEditing: PropTypes.bool,
  label: PropTypes.string,
  margin: PropTypes.string,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  options: PropTypes.array,
  register: PropTypes.bool,
  size: PropTypes.string,
  value: PropTypes.any,
  variant: PropTypes.string,
};

ToggleButtonGroup.defaultProps = {
  allowDeselect: false,
  error: undefined,
  exclusive: true,
  fullWidth: true,
  inline: undefined,
  isEditing: undefined,
  label: '',
  margin: 'normal',
  onChange: undefined,
  options: [],
  register: true,
  size: 'small',
  value: undefined,
  variant: 'outlined',
};

export default ToggleButtonGroup;
